export const generateRandomHexValue = (): string => {
    // Generate random values for Red, Green, and Blue in a pastel range
    const red = Math.floor(150 + Math.random() * 105); // Range: 150-255
    const green = Math.floor(100 + Math.random() * 155); // Range: 100-255
    const blue = Math.floor(200 + Math.random() * 55); // Range: 200-255

    // Convert to hexadecimal and ensure 2 digits
    const redHex = red.toString(16).padStart(2, '0');
    const greenHex = green.toString(16).padStart(2, '0');
    const blueHex = blue.toString(16).padStart(2, '0');

    // Concatenate the hex values
    return `#${redHex}${greenHex}${blueHex}`;
};
